module.exports = __webpack_public_path__ + "static/media/7.88e269f4.JPG";